import { create } from "zustand"
import { type PersistOptions, persist } from "zustand/middleware"
import { jwtDecode } from "jwt-decode"

interface UserState {
  isLogin: boolean
  permissions: string[]
  user: {
    id: string
    username: string
    email: string
    full_name: string
  } | null
  token: string
  login: (token: string, permissions: string[]) => void
  clear(): void
  logout: () => void
  setToken: (token: string) => void
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      isLogin: false,
      permissions: [],
      user: null,
      token: "",
      login: (token: string, permissions: string[]) => {
        const decoded = jwtDecode(token)
        set({ user: decoded as any, isLogin: true, token, permissions })
      },
      clear: () =>
        set({
          isLogin: false,
          permissions: [],
          user: null,
          token: "",
        }),
      logout: () =>
        set({
          isLogin: false,
          permissions: [],
          user: null,
          token: "",
        }),
      setToken: (token: string) => set({ token }),
    }),
    {
      name: "user-storage",
      getStorage: () => localStorage,
    } as PersistOptions<UserState>
  )
)
